export const returnSelectedRows = (selected, obj, selectedIndex) => {
    let newSelected = [];
    if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, obj);
    } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
            selected.slice(0, selectedIndex),
            selected.slice(selectedIndex + 1),
        );
    }
    return newSelected;
}

export const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export const getComparator = (sorting) => {
    const sortingParts = sorting.split(",");
    return sortingParts[1] === 'desc'
        ? (a, b) => descendingComparator(a, b, sortingParts[0])
        : (a, b) => -descendingComparator(a, b, sortingParts[0]);
}

export const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

